import Slider from 'react-infinite-logo-slider'

const Carousel = () => {
    
    return (
        <div className='mt-5'>
            <h2 className="text-uppercase heading border-bottom mb-4 text-center">Companies we have worked with</h2>
            <Slider
                duration={100}
                pauseOnHover={true}
                blurBorders={false}
                blurBorderColor={'#fff'}
            >
                <Slider.Slide>
                    <img src="/assets/img/1.png" alt="any" className='w-100' />
                </Slider.Slide>
                <Slider.Slide>
                    <img src="/assets/img/2.png" alt="any" className='w-100' />
                </Slider.Slide>
                <Slider.Slide>
                    <img src="/assets/img/3.png" alt="any" className='w-100' />
                </Slider.Slide>
                <Slider.Slide>
                    <img src="/assets/img/4.png" alt="any" className='w-100' />
                </Slider.Slide>
                <Slider.Slide>
                    <img src="/assets/img/5.png" alt="any" className='w-100' />
                </Slider.Slide>
                <Slider.Slide>
                    <img src="/assets/img/6.png" alt="any" className='w-100' />
                </Slider.Slide>
                <Slider.Slide>
                    <img src="/assets/img/7.png" alt="any" className='w-100' />
                </Slider.Slide>
                <Slider.Slide>
                    <img src="/assets/img/8.png" alt="any" className='w-100' />
                </Slider.Slide>
                <Slider.Slide>
                    <img src="/assets/img/9.png" alt="any" className='w-100' />
                </Slider.Slide>
                <Slider.Slide>
                    <img src="/assets/img/10.png" alt="any" className='w-100' />
                </Slider.Slide>
                <Slider.Slide>
                    <img src="/assets/img/11.png" alt="any" className='w-100' />
                </Slider.Slide>
                <Slider.Slide>
                    <img src="/assets/img/12.png" alt="any" className='w-100' />
                </Slider.Slide>
                <Slider.Slide>
                    <img src="/assets/img/13.png" alt="any" className='w-100' />
                </Slider.Slide>
                <Slider.Slide>
                    <img src="/assets/img/14.png" alt="any" className='w-100' />
                </Slider.Slide>
                <Slider.Slide>
                    <img src="/assets/img/15.png" alt="any" className='w-100' />
                </Slider.Slide>
                <Slider.Slide>
                    <img src="/assets/img/16.png" alt="any" className='w-100' />
                </Slider.Slide>
                <Slider.Slide>
                    <img src="/assets/img/17.png" alt="any" className='w-100' />
                </Slider.Slide>
                <Slider.Slide>
                    <img src="/assets/img/18.png" alt="any" className='w-100' />
                </Slider.Slide>
                <Slider.Slide>
                    <img src="/assets/img/19.png" alt="any" className='w-100' />
                </Slider.Slide>
                <Slider.Slide>
                    <img src="/assets/img/20.png" alt="any" className='w-100' />
                </Slider.Slide>
                <Slider.Slide>
                    <img src="/assets/img/21.png" alt="any" className='w-100' />
                </Slider.Slide>
                <Slider.Slide>
                    <img src="/assets/img/22.png" alt="any" className='w-100' />
                </Slider.Slide>
            </Slider>
        </div>
    )
}              
                     
export default Carousel;